
import { Component, Mixins } from "vue-property-decorator";
import { IPageNoEditable } from "../../../.././domain/system/document";

@Component
export default class PageNoEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IPageNoEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IPageNoEditable) => T, defaultValue: T) => T;

  get pageCount(): number {
    return this.readPropertyOrDefault(s => s.getPageCount(), 0);
  }

  get currentPageNo(): number {
    return this.readPropertyOrDefault(s => s.getCurrentPageNo(), 0);
  }

  set currentPageNo(value: number) {
    this.writePropertyWhenValid(s => s.setCurrentPageNo(value));
  }
}
